export default __webpack_public_path__ + "/dist/images/recipe-img1.72a37f9b0b7459bb9f9e90e91d881e3f.png";